<div *ngIf="currentLang === 'ja'">
  <div class="manual-main" fxLayout="row" fxLayoutAlign="start start" fxLayoutGap="20px">
    <mat-card appearance="outlined" class="manual-card-half">
      <mat-card-header>
        <mat-card-title><span>各画面の説明</span></mat-card-title>
      </mat-card-header>

    <mat-card-content>
      <div class="dialog-left" fxLayout="column" fxLayoutGap="10px" fxFlex="100%">
        <span class="manual-title">施設管理</span>
        <ul>
          <li><a [href]="topLink">プロジェクト一覧</a></li>
          <li><a [href]="topDialogLink">プロジェクト：編集</a></li>
        </ul>
        <span class="manual-title">プロジェクト</span>
        <ul>
          <li><a [href]="projectLink">プロジェクト情報</a></li>
          <li><a [href]="projectDialogLink">プロジェクト情報：編集</a></li>
          <li><a [href]="uploaderLink">アップロードファイル一覧</a></li>
          <li><a [href]="uploaderDLLink">アップロードファイル一覧（プレゼント用）</a></li>
          <li><a [href]="splatsLink">SPLATS情報</a></li>
        </ul>
        <span class="manual-title">ユーザー</span>
        <ul>
          <li><a [href]="userLink">ユーザー情報</a></li>
          <li><a [href]="userDialogLink">ユーザー情報：編集</a></li>
        </ul>
        <span class="manual-title">掲示板</span>
        <ul>
          <li><a [href]="boardThreadLink">掲示板（スレッド）</a></li>
          <li><a [href]="boardThreadDialogLink">掲示板（スレッド）：編集</a></li>
          <li><a [href]="boardCommentLink">掲示板（コメント）</a></li>
          <li><a [href]="boardCommentDialogLink">掲示板（コメント）：編集</a></li>
        </ul>
        <span class="manual-title">施設</span>
        <ul>
          <li><a [href]="facilityLink">施設情報</a></li>
          <li><a [href]="facilityDialogLink">施設情報：編集</a></li>
          <li><a [href]="hallLink">建物・カテゴリ情報</a></li>
          <li><a [href]="hallDialogLink">建物・カテゴリ情報詳細（追加・編集）</a></li>
          <li><a [href]="floorLink">フロア・表示グループ情報</a></li>
          <li><a [href]="floorDialogLink">フロア・表示グループ情報詳細（追加・編集）</a></li>
          <li><a [href]="facilityUserLink">施設職員情報</a></li>
          <li><a [href]="facilityUserDialogLink">施設職員情報詳細（追加・編集）</a></li>
          <li><a [href]="purchaseContentDailyLink">コンテンツ購入日次情報</a></li>
          <li><a [href]="purchaseContentDailyDialogLink">コンテンツ購入日次情報検索条件</a></li>
        </ul>
        <span class="manual-title">展示</span>
        <ul>
          <li><a [href]="exhibitLink">展示情報</a></li>
          <li><a [href]="exhibitDialogLink">展示情報詳細（追加・編集）</a></li>
          <li><a [href]="exhibitDetailLink">展示詳細情報</a></li>
          <li><a [href]="exhibitDetailDialogLink">展示詳細情報詳細（追加・編集）</a></li>
          <li><a [href]="exhibitRankingLink">ランキング</a></li>
          <li><a [href]="voiceFileDownloadLink">音声ファイルダウンロード</a></li>
        </ul>
        <span class="manual-title">予約</span>
        <ul>
          <li><a [href]="reservationFacilityLink">予約施設情報</a></li>
          <li><a [href]="reservationFacilityReservationLink">施設予約状況：閲覧</a></li>
          <li><a [href]="reservationFacilityDialogLink">予約施設情報詳細（追加・編集）</a></li>
          <li><a [href]="reservationFacilitySpecialLink">予約施設：特別営業日</a></li>
          <li><a [href]="reservationFacilitySpecialDialogLink">予約施設：特別営業日詳細（追加・編集）</a></li>
          <li><a [href]="reservationQuestionLink">予約設問</a></li>
          <li><a [href]="reservationQuestionDialogLink">予約設問詳細（追加・編集）</a></li>
          <li><a [href]="reservationLink">予約状況</a></li>
          <li><a [href]="reservationDialogLink">予約状況詳細（編集）</a></li>
          <li><a [href]="selectReservationDialogLink">予約状況検索条件</a></li>
          <li><a [href]="confirmReservationDialogLink">受付中の予約状況の確定・落選</a></li>
          <li><a [href]="confirmReservationDetailDialogLink">受付中の予約状況の確定・落選 予約状況詳細（編集）</a></li>
          <li><a [href]="reservationDownloadLink">予約状況ダウンロード</a></li>
          <li><a [href]="reservationDownloadDialogLink">予約状況ダウンロードファイル（作成・編集）</a></li>
        </ul>
      </div>
      <div class="dialog-right" fxLayout="column" fxLayoutGap="10px" fxFlex="100%">
        <span class="manual-title">属性</span>
        <ul>
          <li><a [href]="facilityAttributeLink">施設属性情報</a></li>
          <li><a [href]="facilityAttributeDialogLink">施設属性情報詳細（追加・編集）</a></li>
          <li><a [href]="exhibitAttributeLink">展示属性情報</a></li>
          <li><a [href]="exhibitAttributeDialogLink">展示属性情報詳細（追加・編集）</a></li>
          <li><a [href]="exhibitDetailAttributeLink">展示詳細属性情報</a></li>
          <li><a [href]="exhibitDetailAttributeDialogLink">展示詳細属性情報詳細（追加・編集）</a></li>
          <li><a [href]="reservationFacilityAttributeLink">予約施設属性情報</a></li>
          <li><a [href]="reservationFacilityAttributeDialogLink">予約施設属性情報詳細（追加・編集）</a></li>
        </ul>
        <span class="manual-title">通知</span>
        <ul>
          <li><a [href]="noticeLink">通知情報</a></li>
        </ul>
        <span class="manual-title">QR(URL)生成</span>
        <ul>
          <li><a [href]="qrcodeLink">QR(URL)生成ページ選択</a></li>
          <li><a [href]="qrcodeResultLink">QRコード生成結果</a></li>
          <li><a [href]="urlResultLink">URL生成結果</a></li>
        </ul>
        <span class="manual-title">アンケート</span>
        <ul>
          <li><a [href]="questionLink">設問情報</a></li>
          <li><a [href]="questionDialogLink">設問情報詳細（追加・編集）</a></li>
          <li><a [href]="questionSortDialogLink">設問情報詳細（並べ替え）</a></li>
          <li><a [href]="questSetLink">設問セット</a></li>
          <li><a [href]="questSetDialogLink">設問セット詳細（追加・編集）</a></li>
          <li><a [href]="enqueteLink">アンケート結果ダウンロード</a></li>
          <li><a [href]="enqueteDialogLink">アンケート結果ダウンロードファイル（作成・編集）</a></li>
        </ul>
        <span class="manual-title">避難所</span>
        <ul>
          <li><a [href]="shelterLink">避難所情報</a></li>
          <li><a [href]="shelterDialogLink">避難所情報詳細（追加・編集）</a></li>
        </ul>
        <span class="manual-title">入退場管理</span>
        <ul>
          <li><a [href]="entranceExitEventLink">イベント情報</a></li>
          <li><a [href]="entranceExitQuestionLink">イベント設問</a></li>
          <li><a [href]="entranceExitQuestionDialogLink">イベント設問詳細（追加・編集）</a></li>
          <li><a [href]="entranceExitUserLink">スタッフ情報</a></li>
          <li><a [href]="entranceExitUserDialogLink">スタッフ情報詳細（追加・編集）</a></li>
          <li><a [href]="entranceExitEntryLink">エントリー情報</a></li>
          <li><a [href]="selectEntranceExitEntryDialogLink">エントリー情報検索条件</a></li>
          <li><a [href]="entranceExitEntryDialogLink">エントリー情報詳細（編集）</a></li>
          <li><a [href]="entranceExitTransitDialogLink">入退場状況：閲覧</a></li>
          <li><a [href]="entranceExitTransitDailyLink">日次入退場状況</a></li>
          <li><a [href]="selectEntranceExitTransitDailyDialogLink">日次入退場状況検索条件</a></li>
          <li><a [href]="entranceExitTransitDailyDialogLink">日次入退場状況詳細：閲覧</a></li>
          <li><a [href]="entranceExitExhibitTransitDownloadLink">展示来場状況ダウンロード</a></li>
          <li><a [href]="entranceExitExhibitTransitDownloadDialogLink">展示来場状況ダウンロードファイル（作成・編集）</a></li>
        </ul>
        <span class="manual-title">その他</span>
        <ul>
          <li><a [href]="reflectDataLink">本番反映</a></li>
          <li><a [href]="nameDialogLink">名称ダイアログ</a></li>
          <li><a [href]="descDialogLink">詳細ダイアログ</a></li>
          <li><a [href]="youtubeDialogLink">YouTube埋め込みコードダイアログ</a></li>
          <li><a [href]="urlDialogLink">外部リンクURLダイアログ</a></li>
          <li><a [href]="userInputTitleDialogLink">ユーザー入力タイトルダイアログ</a></li>
          <li><a [href]="sendMailTitleDialogLink">メール送信タイトルダイアログ</a></li>
          <li><a [href]="sendMailMessageDialogLink">メール送信本文ダイアログ</a></li>
        </ul>
      </div>
    </mat-card-content>
  </mat-card>

    <mat-card appearance="outlined" class="manual-card-half">
      <mat-card-header>
        <mat-card-title><span>サイト作成の基本的な流れ</span></mat-card-title>
      </mat-card-header>

      <mat-card-content>
        <ol>
          <li>
            ログイン後の<a [href]="topLink">施設管理</a>の画面の鉛筆マークで言語を選択する
          </li>
          <br>
          <li>
            データ管理へのボタンを押して<a [href]="projectLink">プロジェクト情報</a>を登録する
          </li>
          <br>
          <li>
            プロジェクトメニューの<a [href]="uploaderLink">ファイルアップロード</a>から画像を登録する
            <span class="new_line">（番号体系を考えておき、名称の前に番号を入れると便利です）</span>
          </li>
          <br>
          <li>
            展示メニューから<a [href]="exhibitLink">展示情報</a>を登録する
          </li>
          <br>
          <li>
            施設メニューから<a [href]="hallLink">建物・カテゴリ情報</a>を登録する
          </li>
          <br>
          <li>
            施設メニューから<a [href]="floorLink">フロア・表示グループ情報</a>を登録して建物・カテゴリ情報と展示物を紐づける
            <span class="new_line">（企画展情報はフロア・表示グループ情報に登録します）</span>
          </li>
          <br>
          <li>
            施設メニューから<a [href]="facilityLink">施設情報</a>を登録してフロア・表示グループを紐づける
            <span class="new_line">（企画展情報は施設情報に紐づけている状態の時のみ表示されます）</span>
          </li>
          <br>
          <li>
            確認用URLでコンテンツを確認する
          </li>
          <br>
          <li>
            施設情報の本番反映ボタンを押す
            <span class="new_line">（本番への反映は、予約実行、即時実行が可能です）</span>
          </li>
          <br>
        </ol>
      </mat-card-content>
    </mat-card>
  </div>
</div>
<div *ngIf="currentLang === 'en'">
  <div class="manual-main" fxLayout="row" fxLayoutAlign="start start" fxLayoutGap="20px">
    <mat-card appearance="outlined" class="manual-card-half">
      <mat-card-header>
        <mat-card-title><span>Screen Descriptions</span></mat-card-title>
      </mat-card-header>
  
      <mat-card-content>
        <div class="dialog-left" fxLayout="column" fxLayoutGap="10px" fxFlex="100%">
          <span class="manual-title">Facility Management</span>
          <ul>
            <li><a [href]="topLink">Project List</a></li>
            <li><a [href]="topDialogLink">Project: Edit</a></li>
          </ul>
          <span class="manual-title">Project</span>
          <ul>
            <li><a [href]="projectLink">Project Information</a></li>
            <li><a [href]="projectDialogLink">Project Information: Edit</a></li>
            <li><a [href]="uploaderLink">Uploaded Files List</a></li>
            <li><a [href]="uploaderDLLink">Uploaded Files List (Gift)</a></li>
            <li><a [href]="splatsLink">SPLATS Information</a></li>
          </ul>
          <span class="manual-title">User</span>
          <ul>
            <li><a [href]="userLink">User Information</a></li>
            <li><a [href]="userDialogLink">User Information: Edit</a></li>
          </ul>
          <span class="manual-title">Bulletin Board</span>
          <ul>
            <li><a [href]="boardThreadLink">Bulletin Board (Threads)</a></li>
            <li><a [href]="boardThreadDialogLink">Bulletin Board (Threads): Edit</a></li>
            <li><a [href]="boardCommentLink">Bulletin Board (Comments)</a></li>
            <li><a [href]="boardCommentDialogLink">Bulletin Board (Comments): Edit</a></li>
          </ul>
          <span class="manual-title">Facility</span>
          <ul>
            <li><a [href]="facilityLink">Facility Information</a></li>
            <li><a [href]="facilityDialogLink">Facility Information: Edit</a></li>
            <li><a [href]="hallLink">Building/Category Information</a></li>
            <li><a [href]="hallDialogLink">Building/Category Information Details (Add/Edit)</a></li>
            <li><a [href]="floorLink">Floor/Display Group Information</a></li>
            <li><a [href]="floorDialogLink">Floor/Display Group Information Details (Add/Edit)</a></li>
            <li><a [href]="facilityUserLink">Facility Staff Information</a></li>
            <li><a [href]="facilityUserDialogLink">Facility Staff Information Details (Add/Edit)</a></li>
            <li><a [href]="purchaseContentDailyLink">Content Purchase Daily Information</a></li>
            <li><a [href]="purchaseContentDailyDialogLink">Content Purchase Daily Information Search Conditions</a></li>
          </ul>
          <span class="manual-title">Exhibition</span>
          <ul>
            <li><a [href]="exhibitLink">Exhibition Information</a></li>
            <li><a [href]="exhibitDialogLink">Exhibition Information Details (Add/Edit)</a></li>
            <li><a [href]="exhibitDetailLink">Exhibition Detail Information</a></li>
            <li><a [href]="exhibitDetailDialogLink">Exhibition Detail Information Details (Add/Edit)</a></li>
            <li><a [href]="exhibitRankingLink">Ranking</a></li>
            <li><a [href]="voiceFileDownloadLink">Voice File Download</a></li>
          </ul>
          <span class="manual-title">Reservation</span>
          <ul>
            <li><a [href]="reservationFacilityLink">Reservation Facility Information</a></li>
            <li><a [href]="reservationFacilityReservationLink">Facility Reservation Status: View</a></li>
            <li><a [href]="reservationFacilityDialogLink">Reservation Facility Information Details (Add/Edit)</a></li>
            <li><a [href]="reservationFacilitySpecialLink">Reservation Facility: Special Business Days</a></li>
            <li><a [href]="reservationFacilitySpecialDialogLink">Reservation Facility: Special Business Days Details (Add/Edit)</a></li>
            <li><a [href]="reservationQuestionLink">Reservation Questions</a></li>
            <li><a [href]="reservationQuestionDialogLink">Reservation Questions Details (Add/Edit)</a></li>
            <li><a [href]="reservationLink">Reservation Status</a></li>
            <li><a [href]="reservationDialogLink">Reservation Status Details (Edit)</a></li>
            <li><a [href]="selectReservationDialogLink">Reservation Status Search Conditions</a></li>
            <li><a [href]="confirmReservationDialogLink">Confirm/Rejection of reservations in progress</a></li>
            <li><a [href]="confirmReservationDetailDialogLink">Confirm/Rejection of reservations in progress: Reservation Status Details (Edit)</a></li>
            <li><a [href]="reservationDownloadLink">Reservation Status Download</a></li>
            <li><a [href]="reservationDownloadDialogLink">Reservation Status Download File (Create/Edit)</a></li>
          </ul>
        </div>
        <div class="dialog-right" fxLayout="column" fxLayoutGap="10px" fxFlex="100%">
          <span class="manual-title">Attributes</span>
          <ul>
            <li><a [href]="facilityAttributeLink">Facility Attribute Information</a></li>
            <li><a [href]="facilityAttributeDialogLink">Facility Attribute Information Details (Add/Edit)</a></li>
            <li><a [href]="exhibitAttributeLink">Exhibition Attribute Information</a></li>
            <li><a [href]="exhibitAttributeDialogLink">Exhibition Attribute Information Details (Add/Edit)</a></li>
            <li><a [href]="exhibitDetailAttributeLink">Exhibition Detail Attribute Information</a></li>
            <li><a [href]="exhibitDetailAttributeDialogLink">Exhibition Detail Attribute Information Details (Add/Edit)</a></li>
            <li><a [href]="reservationFacilityAttributeLink">Reservation Facility Attribute Information</a></li>
            <li><a [href]="reservationFacilityAttributeDialogLink">Reservation Facility Attribute Information Details (Add/Edit)</a></li>
          </ul>
          <span class="manual-title">Notifications</span>
          <ul>
            <li><a [href]="noticeLink">Notification Information</a></li>
          </ul>
          <span class="manual-title">QR(URL) Generation</span>
          <ul>
            <li><a [href]="qrcodeLink">QR(URL) Generation Page Selection</a></li>
            <li><a [href]="qrcodeResultLink">QR Code Generation Results</a></li>
            <li><a [href]="urlResultLink">URL Code Generation Results</a></li>
          </ul>
          <span class="manual-title">Survey</span>
          <ul>
            <li><a [href]="questionLink">Question Information</a></li>
            <li><a [href]="questionDialogLink">Question Information Details (Add/Edit)</a></li>
            <li><a [href]="questionSortDialogLink">Question Information Details (Sort)</a></li>
            <li><a [href]="questSetLink">Question Set</a></li>
            <li><a [href]="questSetDialogLink">Question Set Details (Edit)</a></li>
            <li><a [href]="enqueteLink">Survey Results Download</a></li>
            <li><a [href]="enqueteDialogLink">Survey Results Download File (Create/Edit)</a></li>
          </ul>
          <span class="manual-title">Shelters</span>
          <ul>
            <li><a [href]="shelterLink">Shelter Information</a></li>
            <li><a [href]="shelterDialogLink">Shelter Information Details (Add/Edit)</a></li>
          </ul>
          <span class="manual-title">Entrance/Exit Management</span>
          <ul>
            <li><a [href]="entranceExitEventLink">Event Information</a></li>
            <li><a [href]="entranceExitQuestionLink">Event Questions</a></li>
            <li><a [href]="entranceExitQuestionDialogLink">Event Questions Details (Add/Edit)</a></li>
            <li><a [href]="entranceExitUserLink">Staff Information</a></li>
            <li><a [href]="entranceExitUserDialogLink">Staff Information Details (Add/Edit)</a></li>
            <li><a [href]="entranceExitEntryLink">Entry Information</a></li>
            <li><a [href]="selectEntranceExitEntryDialogLink">Entry Information Search Conditions</a></li>
            <li><a [href]="entranceExitEntryDialogLink">Entry Information Details (Edit)</a></li>
            <li><a [href]="entranceExitTransitDialogLink">Entrance/Exit Status: View</a></li>
            <li><a [href]="entranceExitTransitDailyLink">Daily Entrance/Exit Status</a></li>
            <li><a [href]="selectEntranceExitTransitDailyDialogLink">Daily Entrance/Exit Status Search Conditions</a></li>
            <li><a [href]="entranceExitTransitDailyDialogLink">Daily Entrance/Exit Status Details: View</a></li>
            <li><a [href]="entranceExitExhibitTransitDownloadLink">Exhibition Visit Status Download</a></li>
            <li><a [href]="entranceExitExhibitTransitDownloadDialogLink">Exhibition Visit Status Download File (Create/Edit)</a></li>
          </ul>
          <span class="manual-title">Others</span>
          <ul>
            <li><a [href]="reflectDataLink">Production Reflection</a></li>
            <li><a [href]="nameDialogLink">Name Dialog</a></li>
            <li><a [href]="descDialogLink">Details Dialog</a></li>
            <li><a [href]="youtubeDialogLink">YouTube Embed Code Dialog</a></li>
            <li><a [href]="urlDialogLink">External Link URL Dialog</a></li>
            <li><a [href]="userInputTitleDialogLink">User Input Title Dialog</a></li>
            <li><a [href]="sendMailTitleDialogLink">Email Title Dialog</a></li>
            <li><a [href]="sendMailMessageDialogLink">Email Message Dialog</a></li>
          </ul>
        </div>
      </mat-card-content>
    </mat-card>
  
    <mat-card appearance="outlined" class="manual-card-half">
      <mat-card-header>
        <mat-card-title><span>Basic Steps for Creating a Site</span></mat-card-title>
      </mat-card-header>
  
      <mat-card-content>
        <ol>
          <li>
            After logging in, select the language by clicking the pencil icon on the <a [href]="topLink">Facility Management</a> screen.
          </li>
          <br>
          <li>
            Click the "Data Management" button and register <a [href]="projectLink">Project Information</a>.
          </li>
          <br>
          <li>
            Upload images from <a [href]="uploaderLink">File Upload</a> in the project menu.
            <span class="new_line">(It's convenient to include a number before the name by considering the numbering system beforehand.)</span>
          </li>
          <br>
          <li>
            Register <a [href]="exhibitLink">Exhibition Information</a> from the Exhibition menu.
          </li>
          <br>
          <li>
            Register <a [href]="hallLink">Building/Category Information</a> from the Facility menu.
          </li>
          <br>
          <li>
            Register <a [href]="floorLink">Floor/Display Group Information</a> from the Facility menu and link it to Building/Category Information and Exhibits.
            <span class="new_line">(Special exhibition information should be registered in Floor/Display Group Information.)</span>
          </li>
          <br>
          <li>
            Register <a [href]="facilityLink">Facility Information</a> from the Facility menu and link it to the Floor/Display Group.
            <span class="new_line">(Special exhibition information is displayed only when it is linked to Facility Information.)</span>
          </li>
          <br>
          <li>
            Check the content with the confirmation URL.
          </li>
          <br>
          <li>
            Click the "Reflect to Production" button in the facility information.
            <span class="new_line">(Reflecting to production can be done through scheduled execution or immediate execution.)</span>
          </li>
          <br>
        </ol>
      </mat-card-content>
    </mat-card>

  </div>
</div>